module.exports = __webpack_public_path__ + "static/media/background.61fa94ab.png";